class DevionChatBot {
    constructor(selector) {
        this.root = document.querySelector(selector);
        if (!this.root) return;
        this.launcherMessageStorageKey = 'devion-chatbot-launcher-message-hidden';

        this.init();
    }

    init() {
        console.log('DevionChatBot: Init triggered.');

        const launcher = this.root.querySelector('.devion-chatbot__launcher');
        if (launcher) {
            launcher.addEventListener('click', this.toggleChat.bind(this));
        } else {
            console.warn('DevionChatBot: .devion-chatbot__launcher not found.');
        }

        const launcherMessageClose = this.root.querySelector('[data-chatbot-launcher-message-close]');
        if (launcherMessageClose) {
            launcherMessageClose.addEventListener('click', (event) => {
                event.stopPropagation();
                this.hideLauncherMessage();
            });
        }

        if (this.isLauncherMessageHidden()) {
            this.hideLauncherMessage({ persist: false });
        }

        this.bindFooterLinks();

        // 🔧 Attach click listeners to action buttons
        const actions = this.root.querySelectorAll('.devion-chatbot__action');
        actions.forEach((button) => {
            button.addEventListener('click', () => {
                const section = button.dataset.section;
                if (section === 'return') {
                    this.openExternalLink('https://eiluminat.ro/pages/formular-retur/#return-request-holder');
                    return;
                } else {
                    console.log('DevionChatBot: Action clicked →', section);
                    this.openLayer(section);
                }

            });
        });

        // 🔙 Attach back buttons if any
        this.bindBackButtons();
    }

    toggleChat() {
        console.log('DevionChatBot: toggleChat triggered!');
        this.root.classList.toggle('devion-chatbot__open');
    }

    hideLauncherMessage({ persist = true } = {}) {
        const launcherMessage = this.root.querySelector('[data-chatbot-launcher-message]');
        if (!launcherMessage) return;

        launcherMessage.classList.add('devion-chatbot__launcher-message--hidden');

        if (persist) {
            try {
                sessionStorage.setItem(this.launcherMessageStorageKey, '1');
            } catch (error) {
                console.warn('DevionChatBot: sessionStorage unavailable.', error);
            }
        }
    }

    isLauncherMessageHidden() {
        try {
            return sessionStorage.getItem(this.launcherMessageStorageKey) === '1';
        } catch (error) {
            console.warn('DevionChatBot: sessionStorage unavailable.', error);
            return false;
        }
    }

    bindFooterLinks() {
        const footerLinks = this.root.querySelectorAll('.devion-chatbot__footer-box[href]');
        footerLinks.forEach((link) => {
            link.addEventListener('click', (event) => {
                const href = link.getAttribute('href');
                if (!href) return;

                if (/^(mailto:|tel:|https:\/\/wa\.me\/|https:\/\/api\.whatsapp\.com\/)/i.test(href)) {
                    event.preventDefault();
                    event.stopPropagation();
                    window.location.href = href;
                }
            });
        });
    }

    openExternalLink(url) {
        if (!url) return;
        console.log('DevionChatBot: Redirecting to', url);
        window.open(url, '_blank');
    }

    openLayer(section) {
        // Închide toate layerele
        const layers = this.root.querySelectorAll('.devion-chatbot__layer');
        layers.forEach((layer) => layer.classList.remove('devion-chatbot__layer--active'));

        // Activează doar layer-ul ales
        const targetLayer = this.root.querySelector(`#layer-${section}`);
        if (targetLayer) {
            // Salut dinamic
            const hour = new Date().getHours();
            const greeting = hour >= 6 && hour < 18 ? 'Bună ziua 👋' : 'Bună seara 🌙';

            // const header = targetLayer.querySelector('.devion-chatbot__layer-header_welcome');
            // if (header) {
            //     header.textContent = `${greeting}, ai ales: ${this.getSectionLabel(section)}`;
            // }

            targetLayer.classList.add('devion-chatbot__layer--active');

            const layerResponseMap = {
                repair: {
                    containerId: 'chat-response-repair',
                    message: `${greeting}, multumim ca ai contactat serviciul de reparatii daca vrei sa citesti politicile noastre de service si garantie <a class="chat_link-redirect" href="https://eiluminat.ro/pages/politica-de-garan%C8%9Bie-%C8%99i-service" target="_blank">Citeste mai mult</a>
                    </br> Dacă preferi să treci direct la completarea cererii, poți face acest lucru dând click pe butonul <i>Este în garanție</i>.`,
                    delay: 1500
                },
                return: {
                    containerId: 'chat-response-return',
                    message: `${greeting}, pentru retur, completează formularul de mai jos. Ai la dispoziție 14 zile de la livrare.`,
                    delay: 1500
                },
                warranty: {
                    containerId: 'chat-response-warranty',
                    message: `${greeting}, </br> Ne pare rău că întâmpini o problemă!
                    </br> 
                    Completează te rugăm formularul de mai jos și atașează poze dacă este cazul. Echipa noastră de service va analiza situația și te va contacta în cel mai scurt timp posibil. 📦🔧
                    `,
                    delay: 1500
                },
                'info-order': {
                    containerId: 'chat-response-info-order',
                    message: `${greeting},  Introdu numărul comenzii tale pentru a verifica rapid statusul livrării.`,
                    delay: 1500
                },
                'offer': {
                    containerId: 'chat-response-offer',
                    message: `${greeting}, ai ajuns în locul potrivit dacă vrei o ofertă personalizată. Completează formularul de mai jos și spune-ne ce produse dorești, iar noi revenim rapid cu o soluție potrivită pentru tine.`,
                    delay: 1500
                },
            };

            if (layerResponseMap[section]) {
                this.showBotResponse(layerResponseMap[section]);
            }
        } else {
            console.warn(`DevionChatBot: Layer #layer-${section} not found.`);
        }
    }
    showBotMessage({ containerId, message, delay = 1500, onComplete = null }) {
        const container = this.root.querySelector(`#${containerId}`);
        if (!container) return;
        container.innerHTML = '';

        const loadingEl = document.createElement('div');
        loadingEl.className = 'devion-chatbot__loading';
        loadingEl.innerHTML = '<span></span><span></span><span></span>';
        container.appendChild(loadingEl);

        setTimeout(() => {
            loadingEl.remove();

            const messageBox = document.createElement('div');
            messageBox.className = 'devion-chatbot__bot-message';
            messageBox.innerHTML = `
            <div class="devion-chatbot__bot-avatar">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path class="bot-blink" d="M13.5002 3.5C13.5002 4.32843 12.8286 5 12.0002 5C11.1718 5 10.5002 4.32843 10.5002 3.5C10.5002 2.67157 11.1718 2 12.0002 2C12.8286 2 13.5002 2.67157 13.5002 3.5Z" stroke="#141B34" stroke-width="1.5"/>
                    <path d="M12.0002 5V8" stroke="#141B34" stroke-width="1.5" stroke-linejoin="round"/>
                    <path d="M17.0002 8H7.00018C5.89561 8 5.00018 8.89543 5.00018 10V18C5.00018 19.1046 5.89561 20 7.00018 20H9.00018V22L12.0002 20H17.0002C18.1048 20 19.0002 19.1046 19.0002 18V10C19.0002 8.89543 18.1048 8 17.0002 8Z" stroke="#141B34" stroke-width="1.5" stroke-linejoin="round"/>
                    <path d="M19.0002 11.5H21.0002C21.5525 11.5 22.0002 11.9477 22.0002 12.5V15.5C22.0002 16.0523 21.5525 16.5 21.0002 16.5H19.0002" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M4.99982 16.5L2.99982 16.5C2.44753 16.5 1.99982 16.0523 1.99982 15.5L1.99982 12.5C1.99982 11.9477 2.44753 11.5 2.99982 11.5L4.99982 11.5" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8.99982 11V13M14.9998 11V13M9.99982 16C9.99982 16 10.3332 16.5 11.9998 16.5C13.6665 16.5 13.9998 16 13.9998 16" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div class="devion-chatbot__bot-bubble">${message}</div>
        `;
            container.appendChild(messageBox);

            if (typeof onComplete === 'function') {
                onComplete(container);
            }
        }, delay);
    }

    showBotResponse({ containerId, message, delay = 1500, type = null }) {
        this.showBotMessage({
            containerId,
            message,
            delay,
            onComplete: (container) => {
                if (containerId === 'chat-response-repair') {
                    const buttonsWrapper = document.createElement('div');
                    buttonsWrapper.className = 'devion-chatbot__actions-group';

                    buttonsWrapper.innerHTML = `
                    <button class="devion-chatbot__button" data-action="back">← Înapoi la meniu</button>
                    <button class="devion-chatbot__button" data-action="in-garantie">Este în garanție</button>
                `;
                    container.appendChild(buttonsWrapper);
                    this.bindDynamicButtons(buttonsWrapper);
                }

                if (containerId === 'chat-response-warranty') {
                    const backButtonWrapper = document.createElement('div');
                    backButtonWrapper.className = 'devion-chatbot__actions-group';
                    backButtonWrapper.innerHTML = `
                        <button class="devion-chatbot__button" data-action="back">← Înapoi la meniu</button>
                    `;
                    container.appendChild(backButtonWrapper);
                    this.bindDynamicButtons(backButtonWrapper);

                    // 📥 Inserare formular MiniCRM sub buton
                    const minicrmWarrantyWrapper = document.createElement('div');
                    minicrmWarrantyWrapper.id = 'minicrm-warranty-form';
                    minicrmWarrantyWrapper.style.marginTop = '20px';
                    container.appendChild(minicrmWarrantyWrapper);

                    if (!minicrmWarrantyWrapper.querySelector('script')) {
                        const script = document.createElement('script');
                        script.async = true;
                        script.src = 'https://r3.minicrm.ro/api/loader.js?76759-0212ici9va0wg30bjnaw2e20376c5q';
                        minicrmWarrantyWrapper.appendChild(script);

                        console.log('📥 Script MiniCRM pentru garanție inserat.');
                    }
                }

                if (containerId === 'chat-response-info-order') {

                    this.insertOrderForm(container);
                }

                if (containerId === 'chat-response-offer') {
                    const minicrmContainer = document.createElement('div');
                    minicrmContainer.id = 'minicrm-offer-form';
                    minicrmContainer.style.marginTop = '20px';
                    container.appendChild(minicrmContainer);

                    const script = document.createElement('script');
                    script.async = true;
                    script.src = 'https://r3.minicrm.ro/api/loader.js?76759-0h5appfihl1y05juxebf0sxceui0gv';
                    container.appendChild(script);

                    console.log('📥 Script MiniCRM pentru ofertă inserat.');
                }

            }
        });
    }


    bindDynamicButtons(wrapper) {
        const buttons = wrapper.querySelectorAll('.devion-chatbot__button');
        buttons.forEach((btn) => {
            btn.addEventListener('click', () => {
                const action = btn.dataset.action;
                switch (action) {
                    case 'back':
                        this.handleBack();
                        break;
                    case 'in-garantie':
                        console.log('✅ Utilizatorul a confirmat că produsul este în garanție.');
                        wrapper.querySelectorAll('[data-action="in-garantie"], [data-action="nu-garantie"]')
                            .forEach((btn) => btn.style.display = 'none');
                        this.insertWarrantyForm();
                        break;
                    default:
                        console.warn('⚠️ Acțiune necunoscută:', action);
                }
            });
        });
    }
    insertWarrantyForm() {
        const formWrapper = this.root.querySelector('#repair-form-wrapper');
        if (!formWrapper) {
            console.warn('⚠️ Nu am găsit containerul pentru formularul de garanție.');
            return;
        }

        if (formWrapper.querySelector('script')) {
            console.log('ℹ️ Formularul este deja încărcat.');
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://r3.minicrm.ro/api/loader.js?76759-1rxfkz2z1m0o2kj9cztw1hkmho3tas';
        script.async = true;

        formWrapper.innerHTML = '';
        formWrapper.appendChild(script);
    }
    closeAllLayers() {
        const layers = this.root.querySelectorAll('.devion-chatbot__layer');
        layers.forEach((layer) => layer.classList.remove('devion-chatbot__layer--active'));
    }
    resetRepairLayer() {
        const container = this.root.querySelector('#chat-response-repair');
        if (container) {
            container.innerHTML = '';

            const formWrapper = this.root.querySelector('#repair-form-wrapper');
            if (formWrapper) {
                formWrapper.innerHTML = '';
            }
        }
    }
    bindBackButtons() {
        const backButtons = this.root.querySelectorAll('.devion-chatbot__back');
        backButtons.forEach((btn) => {
            btn.removeEventListener('click', this.handleBack);
            btn.addEventListener('click', this.handleBack.bind(this));
        });
    }
    handleBack() {
        console.log('DevionChatBot: Back clicked.');

        const activeLayer = this.root.querySelector('.devion-chatbot__layer--active');
        if (activeLayer) {

            activeLayer.style.transform = 'translateX(100%)';
            activeLayer.style.opacity = '0';
            activeLayer.style.pointerEvents = 'none';


            setTimeout(() => {
                activeLayer.classList.remove('devion-chatbot__layer--active');
                activeLayer.style.transform = '';
                activeLayer.style.opacity = '';
                activeLayer.style.pointerEvents = '';
            }, 400);
        }

        this.resetRepairLayer();
    }
    getSectionLabel(section) {
        const labels = {
            repair: 'Formular reparații',
            return: 'Formular retur',
            warranty: 'Informații garanție',
            'info-order': 'Status comandă'
        };
        return labels[section] || 'Secțiune';
    }

    insertOrderForm(container) {
        const wrapper = document.createElement('div');
        wrapper.className = 'devion-chatbot__order-form-wrapper';
        wrapper.innerHTML = `
        <form id="orderForm" class="devion-chatbot__form">
            <label>
                <span>ID Comandă</span>
                <input type="text" id="orderId" placeholder="#1234" />
                <div class="devion-chatbot__error" id="error-orderId"></div>
            </label>
            <label>
                <span>Email</span>
                <input type="email" id="email" placeholder="email@exemplu.com" />
                <div class="devion-chatbot__error" id="error-email"></div>
            </label>
            <label>
                <span>Telefon</span>
                <input type="tel" id="phone" placeholder="07XXXXXXXX" />
                <div class="devion-chatbot__error" id="error-phone"></div>
            </label>
            <button type="submit" id="submitButton" class="devion-chatbot__button-submit">
                <span class="submit-text">Trimite</span>
                <span class="loadersend" style="display: none;">
                    <svg class="spinner" viewBox="0 0 50 50">
                        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle>
                    </svg>
                </span>
            </button>
        </form>
        <div id="orderDetails" style="display:none;"></div>
    `;

        container.appendChild(wrapper);
        this.bindOrderFormEvents();
    }
    bindOrderFormEvents() {
        const form = this.root.querySelector('#orderForm');
        if (!form) return;

        form.addEventListener('submit', async (event) => {
            event.preventDefault();

            const submitBtn = this.root.querySelector('#submitButton');
            const loader = submitBtn.querySelector('.loadersend');
            const text = submitBtn.querySelector('.submit-text');

            const orderId = form.querySelector('#orderId');
            const email = form.querySelector('#email');
            const phone = form.querySelector('#phone');

            const errorOrderId = form.querySelector('#error-orderId');
            const errorEmail = form.querySelector('#error-email');
            const errorPhone = form.querySelector('#error-phone');

            // Reset erori
            errorOrderId.textContent = '';
            errorEmail.textContent = '';
            errorPhone.textContent = '';

            let hasError = false;

            if (!orderId.value.trim()) {
                errorOrderId.textContent = 'ID comanda este obligatoriu.';
                hasError = true;
            }
            // if (!email.value.trim()) {
            //     errorEmail.textContent = 'Emailul este obligatoriu.';
            //     hasError = true;
            // } else if (!/^\S+@\S+\.\S+$/.test(email.value.trim())) {
            //     errorEmail.textContent = 'Emailul nu este valid.';
            //     hasError = true;
            // }
            if (!phone.value.trim()) {
                errorPhone.textContent = 'Telefonul este obligatoriu.';
                hasError = true;
            }

            if (hasError) return;

            // Submit
            submitBtn.disabled = true;
            loader.style.display = 'inline-block';
            text.style.display = 'none';

            const requestData = {
                email: email.value.trim(),
                telefon: phone.value.trim(),
                id_comanda: orderId.value.trim()
            };

            try {
                const res = await fetch("https://coolify.lustreled.ro/api/shopify/eiluminat/order-status", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestData)
                });

                const data = await res.json();
                console.log("📦 Răspuns comanda:", data);

                if (res.ok) {
                    const details = this.root.querySelector('#orderDetails');
                    form.style.display = 'none';
                    details.style.display = 'block';
                    details.innerHTML = `
                    <div class="devion-chatbot__order-summary">
                        <h3>📦 Detalii comandă</h3>
                        <div class="order-info-row">
                        <span>ID comandă:</span>
                        <strong>${data.order_id}</strong>
                        </div>
                        <div class="order-info-row">
                        <span>Status:</span>
                        <strong>${data.order_status}</strong>
                        </div>
                        <div class="order-info-row">
                        <span>Plată:</span>
                        <strong>${data.payment_status}</strong>
                        </div>
                        <div class="order-info-row">
                        <span>Metodă plată:</span>
                        <strong>${data.payment_method}</strong>
                        </div>
                        <div class="order-info-row">
                        <span>Data creare:</span>
                        <strong>${new Date(data.created_at).toLocaleString('ro-RO', {
                        day: '2-digit', month: 'long', year: 'numeric',
                        hour: '2-digit', minute: '2-digit'
                    })}</strong>
                        </div>
                    </div>
                    `;

                    if (data.order_status.toLowerCase() !== 'procesată') {
                        this.showBotMessage({
                            containerId: 'chat-response-info-order',
                            message: 'Comanda nu este procesată încă. Vrei să te contactăm?',
                            delay: 600,
                            onComplete: (container) => {
                                const wrapper = document.createElement('div');
                                wrapper.className = 'devion-chatbot__actions-group';
                                wrapper.innerHTML = `
                                    <button class="devion-chatbot__button devion-chatbot__button-outline" id="insertContactScriptBtn">
                                        📞 Vrei să te contactăm?
                                    </button>
                                `;
                                container.appendChild(wrapper);

                                const btn = wrapper.querySelector('#insertContactScriptBtn');
                                btn.addEventListener('click', () => {
                                    btn.disabled = true;
                                    btn.textContent = 'Se încarcă...';

                                    this.showBotMessage({
                                        containerId: 'chat-response-info-order',
                                        message: 'Perfect, am înregistrat cererea ta. Completează formularul de mai jos pentru a fi contactat.',
                                        delay: 800,
                                        onComplete: (container) => {
                                            const script = document.createElement('script');
                                            script.async = true;
                                            script.src = 'https://r3.minicrm.ro/api/loader.js?76759-02rnjwaf2803fn5gz9jn2e4ey36kco';

                                            script.onload = () => {
                                                console.log('📥 Script MiniCRM încărcat cu succes.');
                                            };

                                            script.onerror = () => {
                                                this.showBotMessage({
                                                    containerId: 'chat-response-info-order',
                                                    message: '⚠️ A apărut o eroare la încărcarea formularului. Te rugăm să încerci din nou.',
                                                    delay: 500
                                                });
                                                btn.disabled = false;
                                                btn.textContent = '📞 Vrei să te contactăm?';
                                            };

                                            container.appendChild(script);
                                        }
                                    });
                                });

                            }
                        });
                    }

                } else {
                    alert(data.error || 'Eroare necunoscută.');
                }
            } catch (e) {
                console.error("Eroare rețea:", e);
                alert("A apărut o eroare. Încearcă din nou.");
            } finally {
                submitBtn.disabled = false;
                loader.style.display = 'none';
                text.style.display = 'inline';
            }
        });
    }

}

document.addEventListener('DOMContentLoaded', () => {
    console.log('DevionChatBot: DOM ready.');
    new DevionChatBot('.devion-chatbot');
});


(function () {
  function initTeaser(teaser) {
    const label = teaser.querySelector('.devion-chatbot__teaser-label');
    const host  = teaser.closest('.devion-chatbot__launcher') || teaser;

    let collapseTimer = null;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setLabelTargetWidth() {
      const prev = label.style.width;
      label.style.width = 'auto';
      const w = Math.ceil(label.scrollWidth); // <- mai robust
      label.style.width = prev || '';
      teaser.style.setProperty('--devion-chatbot-teaser-label-w', w + 'px');
      return w;
    }
    const remeasureSoon = () => requestAnimationFrame(setLabelTargetWidth);

    function expand() {
      teaser.classList.remove('devion-chatbot__teaser--collapsed','devion-chatbot__teaser--slideout');
      teaser.classList.add('devion-chatbot__teaser--expanded');
    }
    function slideOutThenCollapse() {
      teaser.classList.add('devion-chatbot__teaser--slideout');
      teaser.classList.remove('devion-chatbot__teaser--expanded');
      const onEnd = (e) => {
        if (e.propertyName === 'width') {
          teaser.classList.add('devion-chatbot__teaser--collapsed');
          label.removeEventListener('transitionend', onEnd);
        }
      };
      label.addEventListener('transitionend', onEnd);
    }
    const scheduleCollapse = (ms) => { clearTimeout(collapseTimer); collapseTimer = setTimeout(slideOutThenCollapse, ms); };

    // init
    teaser.classList.add('devion-chatbot__teaser--collapsed');
    setLabelTargetWidth();

    // auto: expand la load, stă 3s, apoi se strânge
    const startDelay = reduce ? 0 : 200;
    setTimeout(() => { if (!reduce) { expand(); scheduleCollapse(3000); } }, startDelay);

    // hover/focus/touch
    host.addEventListener('pointerenter', () => { if (!reduce) { clearTimeout(collapseTimer); expand(); } });
    host.addEventListener('pointerleave', () => { if (!reduce) { clearTimeout(collapseTimer); slideOutThenCollapse(); } });
    host.addEventListener('focusin',       () => { if (!reduce) { clearTimeout(collapseTimer); expand(); } });
    host.addEventListener('focusout',      () => { if (!reduce) { clearTimeout(collapseTimer); slideOutThenCollapse(); } });
    host.addEventListener('touchstart',    () => { if (!reduce) { clearTimeout(collapseTimer); expand(); scheduleCollapse(2000); } }, { passive: true });

    // re-măsurări cheie (mobil)
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(remeasureSoon).catch(()=>{}); }
    window.addEventListener('resize', remeasureSoon);
    window.addEventListener('orientationchange', remeasureSoon);
    try {
      const mq = window.matchMedia('(max-width: 480px)');
      mq.addEventListener ? mq.addEventListener('change', remeasureSoon)
                          : mq.addListener && mq.addListener(remeasureSoon);
    } catch (_) {}
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-chatbot-teaser]').forEach(initTeaser);
  });
})();
